/* eslint-disable no-dupe-keys */
export default {
  notification_subscription: {
    name: '订阅管理',
    // 属性（一般与对象内容匹配）
    prop: {
      subscribed_item: '订阅事项',
      notification_strategy: '通知策略',
      notification_strategy_item: '通知策略事项',
      product_select: '商品选择',
      notifiable: '告警通知规则策略',
      notifiable_type: '通知规则类型',
      admins_id: '订阅的管理员',
      admin_email: '管理员的邮箱',
      admin_mobile: '管理员的手机号',
      subscribe_via_email: '邮件订阅',
      subscribe_via_mobile: '手机订阅',
      subscribe_via_type: '订阅方式',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    subscribed_items: {
      alarm: '告警通知',
      work_order: '工单处理',
      product: '商品购买'
    },
    subscribe_via_types: {
      subscribe_via_mobile: '手机订阅',
      subscribe_via_email: '邮件订阅'
    },
    all_notification_strategies: {
      alarm_created_or_resolved: '告警触发/解除',
      group_application_created: '集团加入申请',
      product_order_paid: '商品订单支付'
    },
    alarm_notification_strategies: {
      alarm_created_or_resolved: '告警触发/解除'
    },
    work_order_notification_strategies: {
      group_application_created: '集团加入申请'
    },
    product_notification_strategies: {
      product_order_paid: '商品订单支付'
    },
    // 占位提示
    placeholder: {
      search_notification_subscriptions_subscribe_via_type: '请选择订阅方式',
      search_notification_subscriptions_notification_strategy: '请选择通知策略'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      subscription_trigger_records: '订阅触发记录',
      notification_records: '订阅通知记录'
    },
    // 标签标题
    list_tabs: {
      all: '全部',
      alarm: '告警通知',
      work_order: '工单处理',
      product: '商品购买'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      admin: '订阅者信息',
      alarm_notification_rule: '告警通知规则'
    },
    tips: {
      email_binding: '为了方便查看订阅的邮件,建议可微信绑定邮箱。',
      sms_notification: '短信通知: 仅告警通知事项开通短信通知，其它订阅事项陆续申请中'
    }
  }
}
